export default "__VITE_ASSET__CXAm0Vkg__"